import { createV3Queries } from "@query/utils/createV3Queries";
import { transactionCategoriesApi } from "@api";

export const queriesTransactionCategories = createV3Queries(
  "transactionCategoriesApi",
  transactionCategoriesApi
);
